import { useToast } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function useCopyToClipboard() {
  const { t } = useTranslation();
  const toast = useToast();
  const handleCopyLink = React.useCallback(
    (value: string) => {
      navigator.clipboard.writeText(value);
      toast({
        title: t('registrations.copied'),
        status: 'info',
      });
    },
    [toast, t],
  );
  return handleCopyLink;
}
